import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import publicationService from "./../../../services/MarketingService/PublicationService";
import clientService from "./../../../services/MarketingService/ClientService";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

function AddPublication() {
  const [nom, setNom] = useState("");
  const [objectif, setObjectif] = useState("");
  const [objectifsData, setObjectifsData] = useState([]);
  const [type, setType] = useState("");
  const [typesData, setTypesData] = useState([]);
  const [canalDiffusion, setCanalDiffusion] = useState("");
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);
  const [contenu, setContenu] = useState("");
  const [publicationDate, setPublicationDate] = useState("");
  const [PiecesJoints, setPiecesJoints] = useState("");
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);

  //cible states
  const [genreCible, setGenreCible] = useState("");
  const [genresData, setGenresData] = useState([]);
  const [lieuCible, setLieuCible] = useState("");
  const [ageCible, setAgeCible] = useState("");

  const [erreur, setErreur] = useState(null);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const navigate = useNavigate(); // route

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  // Modifier la date de publication
  const onChangeStartDate = (event) => {
    setPublicationDate(event.target.value);
  };

  //pieces joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);

    // Reset the file input field
    //document.getElementById("pieces-jointes").value = null;
  };

  useEffect(() => {
    AfficherListObjectifs();
    AfficherListTypes();
    AfficherListCanalDiffusion();
    AfficherListGenres();
  }, []);

  /****************  methode pour afficher objectifs **********************/

  const AfficherListObjectifs = () => {
    publicationService
      .AfficherListObjectifs()
      .then((response) => {
        console.log("setObjectifsData",response);
        setObjectifsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };
  /****************  /.methode pour afficher objectifs **********************/

  /****************  methode pour afficher types **********************/

  const AfficherListTypes = () => {
    publicationService
    .AfficherListTypes()
    .then((response) => {
      setTypesData(response.data.success);
    })
    .catch((error) => {
      console.log(error);
      setErreur(error.message);
    });
  };
  /****************  /.methode pour afficher types **********************/

  /****************  methode pour afficher genres **********************/

  const AfficherListGenres = async () => {
    try {
      const response = await clientService.AfficherListGenres();
      setGenresData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  /**************** /. methode pour afficher genres**********************/

  /**************** methode pour afficher CanalDiffusion**********************/

  const AfficherListCanalDiffusion = async () => {
    try {
      const response = await publicationService.AfficherListCanalDiffusion();
      setCanalDiffusionsData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  /**************** /.methode pour afficher CanalDiffusion**********************/

  /****************  methode d'ajout publication **********************/
  const ajouterPublication =  (event) => {
    event.preventDefault();

    // Vérifier que tous les champs existent
    if (
      !nom ||
      !objectif ||
      !type ||
      !canalDiffusion ||
      !contenu ||
      !genreCible ||
      !lieuCible ||
      !ageCible ||
      !publicationDate
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez renseigner tous les champs !");
      return;
    }
    // Vérifier si l'âge est une valeur entière
    if (!Number.isInteger(Number(ageCible))) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir un âge valide !");
      return;
    }

    const currentDate = new Date();
    if (new Date(publicationDate) < currentDate) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "La date de publication doit être supérieure ou égale à la date actuelle !"
      );
      return;
    }
    // Si les entrées sont valides, créer un nouvel objet publication
    const nouveauPublication = {
      nom: nom,
      objectif: objectif,
      type: type,
      canalDiffusion: canalDiffusion,
      contenu: contenu,
      ageCible: ageCible,
      lieuCible: lieuCible,
      genreCible: genreCible,
      publicationDate: publicationDate,
    };

   publicationService
        .ajouterPublication(nouveauPublication, piecesJointesdata)
        .then((response) => {
          console.log(response.data.success);

          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");

          setTimeout(() => {
            navigate(`/PagePublication`);
          }, 2000);
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :" + error);
        });
    
  };
  /****************  /.methode d'ajout publication **********************/

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Publication</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/PagePublication">Publication</a>
                </li>
                <li className="breadcrumb-item active">Creation</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                Ajouter Publication sur les Reseaux Sociaux
              </h3>
            </div>
            <form>
              <div className="card-body">
                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Nom</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Nom"
                        value={nom}
                        onChange={(event) => setNom(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="type">Objectif</label>
                      <select
                        className="custom-select"
                        id="type"
                        value={objectif}
                        onChange={(e) => setObjectif(e.target.value)}
                      >
                        <option value="">--</option>
                        {objectifsData && objectifsData?.map((objectif) => (
                          <option key={objectif} value={objectif}>
                            {objectif}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">
                        Canal de diffusion
                      </label>
                      <select
                        className="custom-select"
                        id="type"
                        value={canalDiffusion}
                        onChange={(e) => setCanalDiffusion(e.target.value)}
                      >
                        <option value="">--</option>
                        {canalDiffusionsData?.map((canalDiffusion) => (
                          <option key={canalDiffusion} value={canalDiffusion}>
                            {canalDiffusion}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <label htmlFor="type">Type</label>
                      <select
                        className="custom-select"
                        id="type"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value="">--</option>
                        {typesData?.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Contenu</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Contenu ..."
                    value={contenu}
                    onChange={(event) => setContenu(event.target.value)}
                  />
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Age Cible</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Age Cible"
                        value={ageCible}
                        onChange={(event) => setAgeCible(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Lieu Cible</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Lieu Cible"
                        value={lieuCible}
                        onChange={(event) => setLieuCible(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="type">Genre Cible</label>
                      <select
                        className="custom-select"
                        id="type"
                        value={genreCible}
                        onChange={(e) => setGenreCible(e.target.value)}
                      >
                        <option value="">--</option>
                        {genresData?.map((genre) => (
                          <option key={genre} value={genre}>
                            {genre}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="pieces-jointes">Pieces jointes</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="pieces-jointes"
                            name="pieces-jointes"
                            value={PiecesJoints}
                            onChange={handlePieceJointeChange}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="pieces-jointes"
                          >
                            {piecesJointesdata.length === 0
                              ? "Choose file"
                              : piecesJointesdata
                                  .map((fichier) => fichier.name)
                                  .join(", ")}
                          </label>
                        </div>
                        {piecesJointesdata.length > 0 && (
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleDeletePieceJointe}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Date et l'heure de publication
                        </label>
                        <TextField
                          variant="outlined"
                          value={publicationDate}
                          onChange={onChangeStartDate}
                          id="datetime-local"
                          type="datetime-local"
                          className="form-control"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                          // className="mt-2"
                          //style={{ backgroundColor: "white"}}
                        />
                      </div>
                    </div>
                  </div>
                  {/* affichage des images  */}
                  <div className="row mt-3">
                    {piecesJointesdata.map((fichier, index) => (
                      <div key={index} className="col-sm-3 text-center mb-3">
                        <img
                          src={URL.createObjectURL(fichier)}
                          alt={fichier.name}
                          style={{ width: "100%", height: "80%" }}
                        />
                        <button
                          className="btn btn-outline-danger col-sm mt-3 mb-3"
                          type="button"
                          onClick={() => handleDeletePieceJointe(index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                  {/* end of affichage des images  */}
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => navigate("/PagePublication")}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={ajouterPublication}
                >
                  Ajouter
                </button>
              </div>
            </form>
          </div>
        </div>
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={2000}
          onClose={handleSuccessClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            variant="filled"
            onClose={handleSuccessClose}
            severity="success"
          >
            {successAlertText}
          </Alert>
        </Snackbar>
      </section>
    </div>
  );
}

export default AddPublication;
